import React from "react";
import {
  FaMapMarkerAlt,
  FaHospital,
  FaGraduationCap,
  FaShoppingBag,
  FaRoad,
} from "react-icons/fa";
import "./ProjectLocation.css";

const nearbyHighlights = [
  {
    icon: <FaRoad />,
    title: "Dhaka-Chittagong Highway",
    distance: "Just 2 Mins Away",
  },
  {
    icon: <FaHospital />,
    title: "Proshanti General Hospital",
    distance: "5 Mins Walk",
  },
  {
    icon: <FaGraduationCap />,
    title: "Rayan Public School & College",
    distance: "Nearby",
  },
  {
    icon: <FaShoppingBag />,
    title: "Local Market & Shopping Mall",
    distance: "Within 500m",
  },
];

const ProjectLocation = () => {
  return (
    <div style={{ background: "#ffffffff" }}>
      <section className="project-location-section">
        <div className="custom-container">
          <div style={{ textAlign: "center" }}>
            <h2>
              PROJECT <span className="styleTitle">LOCATION</span>
            </h2>
            <p className="subtitle">
              Conveniently located with easy access to all essential amenities
            </p>
          </div>

          <div className="location-wrapper">
            {/* Left Side: Map / Location Details */}
            <div className="location-info">
              <div className="address-card">
                <FaMapMarkerAlt className="address-icon" />
                <div>
                  <h3>Our Iconic City</h3>
                  <p>Sanarpar, Demra, Dhaka, Bangladesh</p>
                </div>
              </div>

              <div className="nearby-list">
                <h4>Nearby Highlights</h4>
                <div className="highlights-grid">
                  {nearbyHighlights.map((item, index) => (
                    <div key={index} className="highlight-item">
                      <span className="h-icon">{item.icon}</span>
                      <div>
                        <h5>{item.title}</h5>
                        <small>{item.distance}</small>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Right Side: Interactive Google Map Embed */}
            <div className="map-container">
              <iframe
                title="Project Location Map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14612.871032890647!2d90.4851235!3d23.7039205!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755b6306e987113%3A0x8e8ebfdb4d546db2!2sSanarpar%2C%20Demra%2C%20Dhaka!5e0!3m2!1sen!2sbd!4v1710000000000!5m2!1sen!2sbd"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProjectLocation;
